<template>
  <div class="menu-item">
    <div class="menu-one">
      <div
        class="menu-one-item"
        v-if="Array.isArray(menuOneNode.authModulePojoList)"
      >
        <a-checkbox
          :indeterminate="
            checkNums[menuOneNode.id] > 0 &&
            checkNums[menuOneNode.id] < menuOneNum
          "
          :checked="checkNums[menuOneNode.id] === menuOneNum"
          :value="menuOneNode.id"
          @change="
            (e) =>
              selectAll(
                checkNums[menuOneNode.id],
                menuOneNode,
                e.target.checked,
                -1
              )
          "
          >{{ menuOneNode.moduleName }}</a-checkbox
        >
      </div>
      <div class="menu-one-item no" v-else>
        <a-checkbox
          :checked="selecteds[menuOneNode.id]"
          :value="menuOneNode.id"
          @change="(e) => selectCheck(menuOneNode.id, e.target.checked)"
          >{{ menuOneNode.moduleName }}</a-checkbox
        >
      </div>
    </div>
    <div
      class="menu-two"
      v-if="
        Array.isArray(menuOneNode.authModulePojoList) &&
        !menuOneNode.authModulePojoList.some((item) =>
          Array.isArray(item.authModulePojoList)
        )
      "
    >
      <div
        class="menu-two-item"
        v-for="(menuTwoNode, index) in menuOneNode.authModulePojoList"
        :key="index"
      >
        <a-checkbox
          :checked="selecteds[menuTwoNode.id]"
          :value="menuTwoNode.id"
          @change="(e) => selectCheck(menuTwoNode.id, e.target.checked)"
          >{{ menuTwoNode.moduleName }}</a-checkbox
        >
      </div>
    </div>
    <div
      class="menu-two-three"
      v-if="
        Array.isArray(menuOneNode.authModulePojoList) &&
        menuOneNode.authModulePojoList.some((item) =>
          Array.isArray(item.authModulePojoList)
        )
      "
    >
      <div
        class="menu-two-item"
        v-for="(menuTwoNode, index) in menuOneNode.authModulePojoList"
        :key="index"
      >
        <div class="menu-two-three-item">
          <a-checkbox
            v-if="Array.isArray(menuTwoNode.authModulePojoList)"
            :indeterminate="
              checkNums[menuTwoNode.id] > 0 &&
              checkNums[menuTwoNode.id] < menuTwoNode.authModulePojoList.length
            "
            :checked="
              checkNums[menuTwoNode.id] ===
              menuTwoNode.authModulePojoList.length
            "
            :value="menuTwoNode.id"
            @change="
              (e) =>
                selectAll(
                  checkNums[menuTwoNode.id],
                  menuTwoNode,
                  e.target.checked,
                  menuTwoNode.id
                )
            "
            >{{ menuTwoNode.moduleName }}</a-checkbox
          >
          <a-checkbox
            :checked="selecteds[menuTwoNode.id]"
            :value="menuTwoNode.id"
            @change="(e) => selectCheck(menuTwoNode.id, e.target.checked)"
            v-else
            >{{ menuTwoNode.moduleName }}</a-checkbox
          >
        </div>
        <div
          class="menu-three"
          v-if="Array.isArray(menuTwoNode.authModulePojoList)"
        >
          <a-row :gutter="[16, 16]">
            <a-col
              :span="4"
              v-for="(
                menuThreeNode, threeIndex
              ) in menuTwoNode.authModulePojoList"
              :key="threeIndex"
            >
              <a-checkbox
                :checked="selecteds[menuThreeNode.id]"
                :value="menuThreeNode.id"
                @change="(e) => selectCheck(menuThreeNode.id, e.target.checked)"
                >{{ menuThreeNode.moduleName }}</a-checkbox
              >
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    menuOneNode: {
      //type: Array,
    },
    selecteds: {
      type: Object,
    },
    treeRoot: {},
  },
  data() {
    return {
      checkNums: {},
    };
  },
  computed: {
    menuOneNum() {
      let that = this;
      let nodes = this.treeRoot.first(function (node) {
        return node.model.id === that.menuOneNode.id;
      });
      let nodeArr = nodes.all(function (node) {
        return node.parent;
      });
      if (nodeArr.length > 0) {
        return nodeArr.length - 1;
      } else return 0;
    },
  },
  watch: {
    selecteds: function () {
      this.comCheckNum();
    },
  },
  created() {
    this.comCheckNum();
  },
  methods: {
    comCheckNum() {
      let checkNums = {};
      let selects = this.selecteds;
      let menuOneNode = this.menuOneNode;
      const trvTemp = (list) => {
        let count = 0;
        list.map((item) => {
          if (selects[item.id]) {
            count += 1;
          }
          if (Array.isArray(item.authModulePojoList)) {
            item.authModulePojoList.map((child) => {
              if (selects[child.id]) {
                count += 1;
              }
            });
          }
        });
        return count;
      };
      if (Array.isArray(menuOneNode.authModulePojoList)) {
        checkNums[menuOneNode.id] = trvTemp(menuOneNode.authModulePojoList);
        menuOneNode.authModulePojoList.map((item) => {
          if (Array.isArray(item.authModulePojoList)) {
            console.log(trvTemp(item.authModulePojoList));
            checkNums[item.id] = trvTemp(item.authModulePojoList);
          }
        });
      }
      console.log("checknums", checkNums);
      this.checkNums = checkNums;
    },
    selectAll(num, menuNode, checked, id) {
      //console.log(num,menuNode,checked)
      const ids = [menuNode.id];
      if (Array.isArray(menuNode.authModulePojoList)) {
        menuNode.authModulePojoList.map((menuOneNode) => {
          ids.push(menuOneNode.id);
          if (Array.isArray(menuOneNode.authModulePojoList)) {
            menuOneNode.authModulePojoList.map((menuTwoNode) => {
              ids.push(menuTwoNode.id);
            });
          }
        });
      }
      this.$emit("selectMenuAll", ids, checked, id);
    },
    selectCheck(id, checked) {
      console.log(id);
      this.$emit("select", id, checked);
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../theme.less";
@import "../../../../utils/convertPxToDesighViewport/convertPxToDesighViewport";
//.convertPxToDesighVH(20)[] .convertPxToDesighVW(20)[]
.menu-item {
  display: flex;
  width: 100%;
  margin-bottom: .convertPxToDesighVH(20) [];
  > .menu-one {
    margin-right: .convertPxToDesighVW(20) [];
    //height: 100%;
    > .menu-one-item {
      //height: 100%;
      min-width: .convertPxToDesighVW(90) [];
      //border-right: 1px solid #1890FF;
    }
  }
  > .menu-two {
    width: calc(100% - .convertPxToDesighVW(120) []);
    display: flex;
    flex-direction: row;
    border-left: 1px solid @primary-color;
    padding-left: .convertPxToDesighVW(20) [];
    > .menu-two-item {
      display: flex;
      margin-right: .convertPxToDesighVW(10) [];
    }
  }
  > .menu-two-three {
    width: calc(100% - .convertPxToDesighVW(120) []);
    display: flex;
    flex-direction: column;
    border-left: 1px solid @primary-color;
    padding-left: .convertPxToDesighVW(20) [];
    > .menu-two-item {
      display: flex;
      flex-direction: row;
      margin-bottom: .convertPxToDesighVH(20) [];
      > .menu-two-three-item {
        min-width: .convertPxToDesighVW(90) [];
        margin-right: .convertPxToDesighVW(20) [];
      }
      > .menu-three {
        width: calc(100% - .convertPxToDesighVW(150) []);
        padding-left: .convertPxToDesighVW(20) [];
        border-left: 1px solid @primary-color;
      }
    }
  }
}
</style>
